<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="sms_icom"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_8200"
      data-name="Path 8200"
      d="M8,18h4m4-2v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V5A2,2,0,0,1,6,3H7"
      fill="none"
      :stroke="clr ? clr : '#fff'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8201"
      data-name="Path 8201"
      d="M13.5,11v1.5a.5.5,0,0,0,.816.388L16.633,11H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V9a2,2,0,0,0,2,2Z"
      fill="none"
      :stroke="clr ? clr : '#fff'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path id="Path_8202" data-name="Path 8202" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
